import EmblaCarousel from "embla-carousel";
import tweener from "./../utils/embla-parallax.js";
import { addPrevNextBtnsClickHandlers } from "./../utils/embla-buttons.js";

// accepts second argument in order to en initialized anywhere:
/*

// my-component.js
import embla from './components/embla'
embla(null, document.querySelector('.my-component')) <- only look in this element

*/
export default (ref, { root = document } = {}) => {
  const emblas = Array.from(root.querySelectorAll(".embla"));

  if (!emblas.length) return;

  emblas.map((emblaContainer: HTMLElement) => {
    const { setupTweenParallax } = tweener(
      emblaContainer.dataset.parallax
        ? parseFloat(emblaContainer.dataset.parallax)
        : undefined,
    );

    const viewport = emblaContainer.querySelector(
      ".embla__viewport",
    ) as HTMLElement;
    const prevButton = emblaContainer.querySelector(
      ".embla__prev",
    ) as HTMLElement;
    const nextButton = emblaContainer.querySelector(
      ".embla__next",
    ) as HTMLElement;
    const progressBar = emblaContainer.querySelector(
      ".embla__progress",
    ) as HTMLElement;

    if (!viewport) return;

    const embla = EmblaCarousel(viewport, {
      loop: emblaContainer.dataset.loop === "true",
      skipSnaps: true,
      dragFree: emblaContainer.dataset.dragFree !== undefined ? false : true,
    });
    const removeTweenParallax = setupTweenParallax(embla);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      embla,
      prevButton,
      nextButton,
    );

    function applyProgress() {
      const progress = Math.max(0, Math.min(1, embla.scrollProgress()));
      progressBar.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
    }

    if (progressBar) {
      embla.on("scroll", applyProgress);
    }

    embla
      .on("destroy", removeTweenParallax)
      .on("destroy", removePrevNextBtnsClickHandlers);
  });
};
